define('responsive-gameday/views/render/WrapupViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/wrapup/wrapup','Wax/get!view-templates/linescore/embeddedLinescore'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function WrapupViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/wrapup/wrapup'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' )
            }
        );
    }
    ViewRender.spawn(WrapupViewRender);

    Superclass=WrapupViewRender.superclass;

    return WrapupViewRender;
});
